export enum KnownHttpHeaders {
    Authorization = "Authorization",
    CacheControl = "Cache-Control",
    ContentType = "Content-Type",
    ContentEncoding = "Content-Encoding",
    OcpApimSubscriptionKey = "Ocp-Apim-Subscription-Key",
    OcpApimTrace = "Ocp-Apim-Trace",
    OcpApimTraceLocation = "Ocp-Apim-Trace-Location",
    OcpApimSasToken = "Ocp-Apim-Sas-Token",
    SoapAction = "SOAPAction",
    IfMatch = "If-Match",
    XMsApiName = "X-Ms-Api-Name",
    XMsApiDevPortal = "x-ms-api-devportal",
    XMsClientRequestId = "x-ms-client-request-id"
}